export default __webpack_public_path__ + "static/media/sliderOpensvg.34edbbf7.svg";